import { render } from "./Rule.vue?vue&type=template&id=6ee158a4&scoped=true"
import script from "./Rule.vue?vue&type=script&lang=js"
export * from "./Rule.vue?vue&type=script&lang=js"

import "./Rule.vue?vue&type=style&index=0&id=6ee158a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee158a4"]])

export default __exports__